// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"ccf1a1f8","378":"72f37f58"}[chunkId] + ".chunk.js";
};